export enum CAMERA {
  TOP = "TOP",
  BOTTOM = "BOTTOM",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  SPEED_MOVE = 60.0,
  SPEED_ROTATION = 10,
}
